var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"text-center mt-10"},[_c('v-progress-circular',{staticClass:"mb-0",attrs:{"color":"primary","indeterminate":""}})],1):_c('v-container',{staticStyle:{"padding-bottom":"200px"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }